'use strict';

/**
 *
 * @name: registerLinkedinFactory
 *
 */

function RegisterLinkedinFactory($rootScope, $q, apiUserService, $sessionStorage, APP_CONSTANTS) {

  'ngInject';

  function getAccessToken ({ rememberUser, connectAccount, redirectPath }) {
    $sessionStorage.linkedinAuthConnectAccount = !!connectAccount
    $sessionStorage.linkedinAuthRememberUser = !!rememberUser
    $sessionStorage.linkedinAuthRedirectPath = redirectPath

    const authUrl = encodeURI(`https://www.linkedin.com/oauth/v2/authorization?client_id=${$rootScope.linkedinAppKey}&redirect_uri=${APP_CONSTANTS.linkedinAuthRedirectURL}&scope=r_emailaddress w_member_social r_liteprofile&state=${APP_CONSTANTS.linkedinStateKey}&response_type=code`)

    window.open(authUrl, '_self')
  }

  function getCommitData(remember, code) {
    var deferred = $q.defer();

    var userData = {
      source: 'linkedin',
      socialToken: code,
      roles: ['member'],
      language: $rootScope.lang,
      receiveDailyNewsletter: $sessionStorage.Nowness.userOptions.receiveDailyNewsletter,
      receiveWeeklyNewsletter: $sessionStorage.Nowness.userOptions.receiveWeeklyNewsletter,
      receiveOffers: $sessionStorage.Nowness.userOptions.receiveOffers,
      isPublic: $sessionStorage.Nowness.userOptions.isPublic
    };

    apiUserService
      .register(userData, remember)
      .then(function(result) {

        // passing http status from register -- 200 is logged in, 201 is created
        deferred.resolve([apiUserService.getUser(remember), result[1]]);
      }, function(error) {

        deferred.reject(error);
      });

    return deferred.promise;
  }

  return {
    getAccessToken,
    getCommitData
  };
}

export default RegisterLinkedinFactory;



// WEBPACK FOOTER //
// ./app/components/nn-register/nn-register-linkedin.factory.js